/* ------------------------ these are types of action ----------------------- */

// top anime
export const FETCH_ANIME_REQUEST = "FETCH_ANIME_REQUEST";
export const FETCH_ANIME_FAILURE = "FETCH_ANIME_FAILURE";
export const GET_ALL_TOP_ANIME = "GET_ALL_TOP_ANIME";
export const GET_TOP_AIRING_ANIME = "GET_TOP_AIRING_ANIME";
export const GET_TOP_UPCOMING_ANIME = "GET_TOP_UPCOMING_ANIME";
export const GET_TOP_TV_SERIES_ANIME = "GET_TOP_TV_SERIES_ANIME";
export const GET_TOP_MOVIES_ANIME = "GET_TOP_MOVIES_ANIME";
export const GET_TOP_OVAS_ANIME = "GET_TOP_OVAS_ANIME";
export const GET_TOP_SPECIAL_ANIME = "GET_TOP_SPECIAL_ANIME";
export const GET_MOST_POPULAR_ANIME = "GET_MOST_POPULAR_ANIME";
export const GET_MOST_FAVORITED_ANIME = "GET_MOST_FAVORITED_ANIME";

// seasonal anime
export const GET_SEASONAL_ANIME = "GET_SEASONAL_ANIME";

// top 5 anime character
export const GET_TOP_ANIME_CHARACTERS = "GET_TOP_ANIME_CHARACTERS";

// anime character information
export const GET_CHARACTER_INFO = "GET_CHARACTER_INFO";
export const GET_CHARACTER_PHOTOS = "GET_CHARACTER_PHOTOS";